module.exports = __webpack_public_path__ + "assets/images/JMD1000.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMD1000.png
// module id = 1385
// module chunks = 1